import { useState, useEffect } from 'preact/hooks';
import Modal from './shared/Modal.jsx';
import Button from './shared/Button.jsx';
import { formatEuros } from '../lib/format.js';

// Afvinken dat een factuur betaald is. Why: met een datumveld en niet met de
// datum van vandaag, omdat je meestal een paar dagen later kijkt en de
// bijschrijvingsdatum wilt vastleggen, niet de dag waarop je het afvinkt.
export default function InvoicePaidModal({ isOpen, invoice, onClose, onConfirm }) {
  const [paidOn, setPaidOn] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    setPaidOn(new Date().toISOString().slice(0, 10));
    setBusy(false);
  }, [isOpen]);

  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    await onConfirm(paidOn);
    setBusy(false);
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={`Betaald: ${invoice?.number || ''}`}>
      <form onSubmit={submit} class="app-form">
        <p class="muted small">
          {invoice?.debtor?.name} · {invoice ? formatEuros(invoice.totalCents) : ''} ·
          {' '}vervalt {invoice?.dueDate}
        </p>
        <label>
          <span>Datum van bijschrijving</span>
          <input type="date" value={paidOn} onInput={e => setPaidOn(e.currentTarget.value)} required />
        </label>
        <div class="form-actions">
          <Button variant="ghost" type="button" onClick={onClose}>Annuleren</Button>
          <Button type="submit" disabled={busy || !paidOn}>{busy ? 'Bezig…' : 'Afvinken'}</Button>
        </div>
      </form>
    </Modal>
  );
}
